<div class="container-fluid-2">
  <div class="row companies-search">
    <div class="col-md-offset-4 col-md-4 col-sm-12">
      <div class="flex items-baseline justify-between">
        <h3>{{ 'MANAGE_COMPANIES' | translate }}</h3>
        <sc-export-button
          *canSee="userType.Admin"
          cssClass="toolbar-button"
          show="xls, csv, json"
          [loading]="loadingExport"
          (export)="onExport($event)"></sc-export-button>
      </div>
      <mat-card class="no-padding-top no-padding-bottom px-4">
        <sc-company-search
          [redirectOnSearch]="true"
          (search)="onSearch($event)"
          (itemSelected)="selectCompany($event)"></sc-company-search>
      </mat-card>

      <div class="companies-buttons">
        <button mat-raised-button color="primary" (click)="addCompany()">
          <mat-icon>add</mat-icon>
          {{ 'ADD_COMPANY' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
